import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../lib/utils.js";
import { AnimatePresence, motion } from "motion/react";
import { useState, useCallback, useEffect } from "react";
const FlipWords = ({
  words,
  duration = 3e3,
  className
}) => {
  const [currentWord, setCurrentWord] = useState(words[0]);
  const [isAnimating, setIsAnimating] = useState(false);
  const startAnimation = useCallback(() => {
    const word = words[words.indexOf(currentWord) + 1] || words[0];
    setCurrentWord(word);
    setIsAnimating(true);
  }, [currentWord, words]);
  useEffect(() => {
    if (!isAnimating)
      setTimeout(() => {
        startAnimation();
      }, duration);
  }, [isAnimating, duration, startAnimation]);
  return /* @__PURE__ */ jsx(
    AnimatePresence,
    {
      onExitComplete: () => {
        setIsAnimating(false);
      },
      children: /* @__PURE__ */ jsx(
        motion.div,
        {
          initial: {
            opacity: 0,
            y: 10
          },
          animate: {
            opacity: 1,
            y: 0
          },
          transition: {
            type: "spring",
            stiffness: 100,
            damping: 10
          },
          exit: {
            opacity: 0,
            y: -40,
            x: 40,
            filter: "blur(8px)",
            scale: 2,
            position: "absolute"
          },
          className: cn(
            "tw:z-10 tw:inline tw:relative tw:text-left",
            className
          ),
          children: currentWord.split(" ").map((word, wordIndex) => /* @__PURE__ */ jsxs(
            motion.span,
            {
              initial: { opacity: 0, y: 10, filter: "blur(8px)" },
              animate: { opacity: 1, y: 0, filter: "blur(0px)" },
              transition: {
                delay: wordIndex * 0.3,
                duration: 0.3
              },
              className: "tw:inline-block tw:whitespace-nowrap",
              children: [
                word.split("").map((letter, letterIndex) => /* @__PURE__ */ jsx(
                  motion.span,
                  {
                    initial: { opacity: 0, y: 10, filter: "blur(8px)" },
                    animate: { opacity: 1, y: 0, filter: "blur(0px)" },
                    transition: {
                      delay: wordIndex * 0.3 + letterIndex * 0.05,
                      duration: 0.2
                    },
                    className: "tw:inline-block",
                    children: letter
                  },
                  word + letterIndex
                )),
                /* @__PURE__ */ jsx("span", { className: "tw:inline-block", children: " " })
              ]
            },
            word + wordIndex
          ))
        },
        currentWord
      )
    }
  );
};
export {
  FlipWords
};
//# sourceMappingURL=flip-words.js.map
